import { FC } from 'react'
import { Flex, Text, Box, Badge } from '@chakra-ui/react'

import { FormItem } from 'components'
import { CUSTOM_FORM_KIND_NAME } from 'components/tools/CustomForm/constants'
import { CustomFormAnswer } from 'components/tools/CustomForm/types'
import CustomFormValidateUploadDataModal from 'components/tools/CustomForm/commonComponents/CustomFormValidateUploadDataModal'
import CustomFormAnswerSelection from './components/CustomFormAnswerSelection'
import { useCustomFormAnswer } from '../../contexts/CustomFormViewerQuestionManager/Provider'

type Props = {
  defaultAnswer?: CustomFormAnswer
  totalAnswers: number
  index: number
}

const CustomFormAnswerItem: FC<Props> = ({ defaultAnswer, totalAnswers, index }) => {
  const { answer } = useCustomFormAnswer()

  const currentAnswer = defaultAnswer || answer

  return (
    <Box
      bg="bgContent"
      rounded="md"
      p={2}
      border="1px solid"
      borderColor="borderColor"
      _hover={{ borderColor: 'primary' }}
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="borderColor"
        pb={2}
        mb={2}
      >
        <Badge>{CUSTOM_FORM_KIND_NAME[currentAnswer?.kind || 'Desconhecido']}</Badge>

        <Flex align="center" gap={1}>
          {answer.settings?.has_data_validation && <CustomFormValidateUploadDataModal answer={answer} />}

          <Text variant="secondary">
            <Text as="span">{Number(index) + 1}</Text>
            <Text as="span">/{totalAnswers}</Text>
          </Text>
        </Flex>
      </Flex>

      <FormItem label={currentAnswer.title}>
        <CustomFormAnswerSelection />
      </FormItem>
    </Box>
  )
}

export default CustomFormAnswerItem
